import { createContext } from 'react';

import { useSettings } from 'hooks/useSettings';

export const SettingsContext = createContext<{
  isLoading: boolean;
  refetch: () => void | undefined;
  settings: Record<string, any> | undefined;
}>({
  isLoading: false,
  refetch: undefined,
  settings: undefined,
});

export const SettingsProvider = ({ children }) => {
  const { data, isLoading, refetch } = useSettings();

  return (
    <SettingsContext.Provider
      value={{
        refetch,
        isLoading,
        settings: data,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};
